import type { JSX } from "react";
import type { ClassNameProp } from "@charterindex/armoury-www";
import type { DeletionVerb } from "../../crud-operation/delete-operation";
import { Alert, AlertTitle } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";


export type PermanentlyDeleteAlertProps = ClassNameProp & {
	resourceName: string | null;
	square?: boolean;
	verb?: DeletionVerb;
};
export const PermanentlyDeleteAlert = (p: PermanentlyDeleteAlertProps): JSX.Element => {
	const { t } = useTranslation();

	return (
		<Alert className={ p.className } severity="warning" square={ p.square }>
			<AlertTitle>
				<Trans
					t={ t }
					i18nKey={ `common:${p.verb ?? "delete"}Permanently` }
					values={{ name: p.resourceName }}
					components={{ strong: <strong/> }}
				/>
			</AlertTitle>
			{ t("common:noUndo") }
		</Alert>
	);
};
